(function () {
  Motion.file('close.js', function (require) {
    Motion.staticStyles('Close', {
      '$': '#_motiondevtools .ViewClose'
    }, {
      '$': {
        position: 'absolute',
        right: 0,
        top: 0,

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: 1,
        opacity: 0.15,
        cursor: 'pointer',
        transition: 'all ease-in 200ms'

      }
    });
    Motion.viewRoots["Close"] = 'close';
    Motion.view('Close', function (view, on, $) {
      ;view.render(function () {
        return view.el(
          ['close', 1],
          { onClick: view.props.onClick },
          'x'
        );
      });

      $["$"] = function (_, _index) {
        return { fontSize: view.props.fontSize || 13,
          width: view.props.size || 50,
          height: view.props.size || 50, ':hover': {
            opacity: 0.4
          }
        };
      };
    });
  })
})();
//# sourceMappingURL=close.js.map
